import { useState, useEffect } from "react";
import { Table, Button, Popconfirm, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useAttributeManagerActions } from "@iso/actions/attributeManager.actions";
import AddEditAttributeModal from "./AddEditAttribute";
import useAuthor from "hooks/useAuthor";
import FilterGroup from "component/FilterGroup";
import AsyncButton from "component/AsyncButton";

const Attribute = (props) => {
   const [isLoading, setIsLoading] = useState(true);
   const [isSubmitting, setIsSubmitting] = useState({});
   const [modalAttributeState, setModalAttributeState] = useState({
      visible: false,
      data: null,
   });
   const [data, setData] = useState({
      dataSource: [],
      paging: {
         current: 1,
         total: 0,
         pageSize: 10,
      },
   });
   const [dataAttributeType, setDataAttributeType] = useState([]);
   const [currentFilters, setCurrentFilters] = useState({});
   const { checkRoles } = useAuthor();
   const attributeActions = useAttributeManagerActions();

   const getDataAttributeType = async () => {
      try {
         const resGet = await attributeActions.getAllAttributeTypeList();
         setDataAttributeType(resGet);
      } catch (error) {
         console.log(error);
      }
   };

   const columns = [
      {
         title: "Attribute Type",
         dataIndex: ["attribute_type", "name"],
         key: "attribute_type",
         align: "center",
      },
      {
         title: "Name",
         dataIndex: "name",
         key: "name",
         align: "center",
      },
      {
         title: "Value",
         dataIndex: "value",
         key: "value",
         align: "center",
      },
      {
         title: "Actions",
         align: "center",
         fixed: "right",
         width: 180,
         render: (record) => (
            <>
               <div className="flex justify-center gap-3">
                  {checkRoles(["attribute_edit"]) && (
                     <Button
                        type="primary"
                        onClick={() =>
                           handleToggleModalAttributeState(true, record)
                        }
                     >
                        Update
                     </Button>
                  )}
                  {checkRoles(["attribute_delete"]) && (
                     <Popconfirm
                        title="Are you sure to delete this attribute?"
                        onConfirm={() =>
                           handleDeleteAttributeType(record["id"])
                        }
                        placement="bottom"
                        okText="Yes"
                        cancelText="No"
                     >
                        <AsyncButton
                           isLoading={isSubmitting[record["id"]] || false}
                           type="primary"
                           style={{ marginLeft: 8 }}
                        >
                           Delete
                        </AsyncButton>
                     </Popconfirm>
                  )}
               </div>
            </>
         ),
      },
   ];

   const getData = async (page, limit, filters) => {
      try {
         setIsLoading(true);
         const resGet = await attributeActions.getAttributeList({
            page: page,
            limit,
            ...filters,
         });
         setData({
            paging: {
               current: parseInt(resGet.page),
               total: parseInt(resGet.total),
               pageSize: parseInt(resGet.limit),
            },
            dataSource: resGet?.data,
         });
      } finally {
         setIsLoading(false);
      }
   };

   const handleTableChange = (pagination) => {
      getData(pagination.current, pagination.pageSize, currentFilters);
   };

   const handleToggleModalAttributeState = (visible, data) => {
      setModalAttributeState({
         visible: visible,
         data: data || null,
      });
   };

   const handleDeleteAttributeType = async (id) => {
      try {
         const currentIsSubmitting = { ...isSubmitting };
         currentIsSubmitting[`${id}`] = true;
         setIsSubmitting(currentIsSubmitting);
         await attributeActions.deleteAttribute(id);
         message.success("Delete attribute success!!!");
         handleTableChange(data?.paging);
      } finally {
         const currentIsSubmitting = { ...isSubmitting };
         delete currentIsSubmitting[id];
         setIsSubmitting(currentIsSubmitting);
      }
   };

   useEffect(() => {
      getDataAttributeType();
      getData(1, data.paging.pageSize, currentFilters);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props?.currentTab]);

   return (
      <>
         <div className="flex justify-between mt-4 mb-8">
            <FilterGroup
               currentFilters={currentFilters}
               setCurrentFilters={setCurrentFilters}
               onGetFilterProperties={
                  attributeActions.getFilterPropertiesAttribute
               }
               onGetOptionsProperty={
                  attributeActions.getOptionsPropertyAttribute
               }
               onFilter={(filters) =>
                  getData(1, data?.paging?.pageSize, filters)
               }
            />

            {checkRoles(["attribute_add"]) && (
               <Button
                  type="primary"
                  onClick={() => handleToggleModalAttributeState(true)}
               >
                  <p className="flex items-center">
                     <PlusOutlined />
                     <span className="ml-2">Add Attribute</span>
                  </p>
               </Button>
            )}
         </div>

         <AddEditAttributeModal
            modalAttributeState={modalAttributeState}
            handleToggleModalAttributeState={handleToggleModalAttributeState}
            getData={getData}
            dataAttributeType={dataAttributeType}
         />

         <Table
            columns={columns?.filter((col) => {
               if (col.title === "Actions") {
                  return (
                     checkRoles(["attribute_edit"]) ||
                     checkRoles(["attribute_delete"])
                  );
               }
               return true;
            })}
            onChange={handleTableChange}
            rowKey="key"
            dataSource={data.dataSource}
            loading={isLoading}
            scroll={{ x: 1200 }}
            pagination={{
               current: data.paging.current,
               total: data.paging.total,
               pageSize: data.paging.pageSize,
            }}
         />
      </>
   );
};

export default Attribute;
